<template>
  <div class="wrapper-container">
    <div class="container-widget-header">
      <h3>ALL POPULAR PRODUCTS</h3>
      <div class="call-actions">
        <button class="btn-success" @click="addNew()">
          <img src="@/assets/images/icons/plus.svg" /> ADD PRODUCTS
        </button>
      </div>
    </div>
    <div class="body-widget">
      <div class="table-widget">
        <table>
          <tr>
            <th>Title</th>
            <th>Image</th>
            <th>Status</th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in section_data" :key="index" :class="{ active: item.status == 'published' }">
            <td>{{ item.product_name }}</td>
            <td>
              <img width="80" :src="$store.state.SITE_ASSETS_BASE_URL +
                'assets/uploaded/' +
                item.main_image
                " />
            </td>
            <td>{{ item.status }}</td>
            <td>
              <dropdown-menu v-model="item.is_menu_open" :right="false" :hover="false" :interactive="true"
                class="shop-menu">
                <button class="dropdown-toggle">
                  <img src="@/assets/images/icons/menu.svg" />
                </button>
                <div slot="dropdown" class="drop-down-menu">
                  <a class="dropdown-item" @click.prevent="editItem(item)">
                    <img src="@/assets/images/icons/edit.svg" /> Edit
                  </a>
                  <a class="dropdown-item" @click.prevent="deleteItem(item)">
                    <img src="@/assets/images/icons/trash.svg" /> Delete
                  </a>
                </div>
              </dropdown-menu>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- Add Modal -->
    <div class="overlay" v-if="show_form">
      <div class="form-widget">
        <div class="header">
          <h3 v-if="!form.id">Add product</h3>
          <h3 v-else>Update item</h3>
        </div>
        <div class="body">
          <div class="input-group">
            <label>Select Product</label>
            <div class="input-widget">
              <selectProductsModal v-model="form.product_id"></selectProductsModal>
            </div>
          </div>
          <div class="input-group">
            <label>Story Prio</label>
            <div class="input-widget">
              <input type="number" v-model="form.prio" class="bg-cagura-form-control" />
            </div>
          </div>
          <div class="input-group">
            <label>Story Status</label>
            <div class="input-widget">
              <select v-model="form.status" class="bg-cagura-form-control">
                <option value="pending">Pending</option>
                <option value="published">Published</option>
              </select>
            </div>
          </div>
        </div>
        <div class="footer">
          <c-button :loading="loading" @click="submitForm()" class="btn-success">Save</c-button>
          <button @click="show_form = false" class="btn-default">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    loading: false,
    form: {
      id: null,
      product_id: "",
      prio: 1,
      status: "pending",
    },
    section_data: [],
    show_form: false,
    shops_data: [],
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getSectionData();
  },
  methods: {
    confirmDelete(id) {
      let vm = this;
      vm.$store
        .dispatch("PRODUCT_POPULAR_DELETE", { id: id })
        .then((response) => {
          vm.getSectionData();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          console.error("STORY_DELETE", { response });
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    deleteItem(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.confirmDelete(item.popular_id);
          }
        },
      });
    },
    editItem(item) {
      let vm = this;
      vm.form.id = item.popular_id;
      vm.form.product_id = item.id;
      vm.form.prio = item.prio;
      vm.form.status = item.status;
      vm.show_form = true;
    },
    getSectionData() {
      let vm = this;
      vm.$store
        .dispatch("PRODUCT_POPULAR_GET_ALL")
        .then((response) => {
          vm.section_data = response.data.return.map((item) => {
            vm.$store.state.eventBus.$set(item, "is_menu_open", false);
            return item;
          });
        })
        .catch(({ response }) => {
          console.log("PRODUCT_POPULAR_GET_ALL", { error });
        });
    },
    submitForm() {
      let vm = this;
      vm.loading = true;
      if (!vm.form.id) {
        vm.$store
          .dispatch("PRODUCT_POPULAR_ADD_NEW", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.getSectionData();
            vm.show_form = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
            console.log("PRODUCT_POPULAR_ADD_NEW", { error });
          });
      } else {
        vm.$store
          .dispatch("PRODUCT_POPULAR_UPDATE", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.getSectionData();
            vm.show_form = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
            console.log("PRODUCT_POPULAR_UPDATE", { error });
          });
      }
    },
    addNew() {
      let vm = this;
      vm.show_form = true;
      vm.form = {
        id: null,
        product_id: "",
        prio: 1,
        status: "pending",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper-container {
  display: flex;
  flex-direction: column;

  .container-widget-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;

    .call-actions {
      display: flex;

      button {
        margin-left: 10px;
      }
    }
  }

  .body-widget {
    height: calc(100vh - 122px);
    overflow-y: auto;

    .table-widget {
      width: 100%;
      padding: 0px 10px;

      table {
        width: 100%;

        tr {
          &.active {
            background: rgb(79, 238, 217);
          }
        }

        th {
          height: 45px;
          background: #ddd;
          border: 1px solid #fff;
          padding: 15px;
        }

        td {
          border: 1px solid #ddd;
          padding: 15px;

          .shop-menu {
            position: relative;
          }

          .affiliate-image {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }

  .overlay {
    display: flex;
    justify-content: center;
    padding-top: 80px;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    align-items: unset;

    .form-widget {
      height: 600px;
      width: 400px;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 5px;
      display: flex;
      flex-direction: column;

      .header {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 15px;
        border-bottom: 1px solid #ccc;

        h3 {
          margin: 0px;
        }
      }

      .body {
        height: calc(100% - 120px);
        overflow-y: auto;
        padding: 15px;

        .story-widget {
          table {
            width: 100%;

            tr {
              th {
                border: 1px solid #ddd;
                padding: 5px;
              }

              td {
                border: 1px solid #ddd;
                padding: 5px;

                select {
                  height: 40px;
                  width: 100%;
                }
              }
            }
          }
        }
      }

      .footer {
        background: rgb(250, 250, 250);
        border-top: 1px solid #ccc;
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 15px;

        button {
          margin-right: 20px;
        }
      }
    }
  }

  .on-fly-options {
    position: fixed;
    bottom: 20px;
    right: 20px;

    .btn-cycle {
      height: 50px !important;
      width: 50px !important;
      min-width: 50px !important;
      border-radius: 50%;
      font-size: 29px;
      background: #fff;
      box-shadow: 0px 0px 6px #000;
    }
  }
}
</style>
